<div class="d-flex vh-100 vw-100">
    <!-- <div class="h-100 shadow w-100 d-none d-md-block d-lg-block d-xl-block"
        style="max-width: 250px;backdrop-filter: blur(10px);background: rgba(255, 255, 255, 0.8);">
        <div class="d-flex flex-column justify-content-between p-0 m-0">
            <div class="d-flex align-items-center justify-content-center display-6 py-3 px-3 text-center">
                <img src="./images/uiConcept/Logos/Dark/Logo_V2_Dark.png" class="w-100" style="max-width: 130px; cursor: pointer;" (click)="navigateToDashboard()">
            </div>
            
            <div class="d-flex justify-content-start" *ngIf="dataService.isActive">
                <div class="d-flex flex-column gap-2 w-100 p-3">
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'Dashboard' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/dashboard">
                        <mat-icon>dashboard icon</mat-icon>Dashboard
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'Create New Task' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/create-task-demo" *ngIf="dataService.role == 'doctor'">
                        <mat-icon>add</mat-icon>New Design
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'My Tasks' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/task-list/my" *ngIf="dataService.role == 'designer'">
                        <mat-icon>pending_actions</mat-icon>My Tasks
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'In Progress Tasks' }" *ngIf="dataService.role == 'doctor'"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/task-list/in-progress">
                        <mat-icon>pending_actions</mat-icon>In Progress
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'Delivered' }" *ngIf="dataService.role == 'doctor'"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/task-list/delivered">
                        <mat-icon>inbox</mat-icon>Delivered
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'Completed Tasks' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/task-list/complete">
                        <mat-icon>check_circle</mat-icon>Complete
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'Designer List' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/designer-list" *ngIf="dataService.role == 'doctor'">
                        <mat-icon>book</mat-icon>Designer List
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'Notifications' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        mat-menu-item routerLink="/notifications" >
                        <mat-icon>notifications</mat-icon>Notifications
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'User List' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        routerLink="/user-list" *ngIf="dataService.role === 'tl' || dataService.role === 'admin'">
                        <mat-icon>supervised_user_circle</mat-icon>User List
                    </button>
                    <button [ngClass]="{ 'active': dataService.pageTitle === 'Admin' }"
                        class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                        routerLink="/admin" *ngIf="dataService.role === 'admin'">
                        <mat-icon>admin_panel_settings</mat-icon>Admin
                    </button>
                      
                </div>
            </div>
        </div>
    </div> -->
    <div class="h-100 w-100 d-flex flex-column">
        <div class="d-flex gap-3 w-100 justify-content-between" style="backdrop-filter: blur(10px);background: rgba(255,255,255,0.8); height: 66px; border-bottom: 2px solid #E4E4E4">
            <div class="d-flex align-items-center px-4">
                <div class="d-flex align-items-center gap-2 pe-4">
                    <img src="./images/uiConcept/Logos/Dark/Logo_V1_Dark.png" class="w-100" style="max-width: 130px; cursor: pointer;" (click)="navigateToDashboard()">
                </div>
                <div class="d-flex ps-4 gap-4">

                    <div class="d-flex flex-column pt-2">
                        <p routerLink="/dashboard" class="m-0 align-content-center" style="height: 54px; cursor: pointer;">
                            Dashboard
                        </p>
                        <div [ngStyle]="{'border': dataService.pageTitle === 'Dashboard' ? '2px solid' : ''}" ></div>
                    </div>

                    <div *ngIf="dataService.role == 'doctor'" class="d-flex flex-column pt-2">
                        <p (click)="openNewTask()" class="m-0 align-content-center" style="height: 54px; cursor: pointer; background: linear-gradient(92.62deg, #295852 -22.28%, #4DA68A 10.52%, #EB14EB 108.91%); background-clip: text; -webkit-text-fill-color: transparent; color: #295852;">
                            New Design
                        </p>
                        <div [ngStyle]="{
                            'border': dataService.pageTitle === 'Create New Task' ? '2px solid' : '',
                            'border-image-source': dataService.pageTitle === 'Create New Task' ? 'linear-gradient(90deg, #295852 0%, #4DA68A 25%, #EB14EB 100%)' : '',
                            'border-image-slice': dataService.pageTitle === 'Create New Task' ? '1' : ''
                        }" ></div>
                    </div>

                    <div class="d-flex flex-column pt-2">
                        <p (click)="openAllOrders()" class="m-0 align-content-center" style="height: 54px; cursor: pointer;">
                            Orders
                        </p>
                        <div [ngStyle]="{'border': dataService.pageTitle === 'In Progress Tasks' ? '2px solid' : ''}" ></div>
                    </div>


                    <div *ngIf="dataService.role == 'admin'" class="d-flex flex-column pt-2">
                        <p routerLink="/task-assign" class="m-0 align-content-center" style="height: 54px; cursor: pointer;">
                            ORDER DETAILS 
                        </p>
                        <div [ngStyle]="{'border': dataService.pageTitle === 'Task Assigend' ? '2px solid' : ''}" ></div>
                    </div>

                    <!-- <div *ngIf="dataService.role == 'admin'" class="d-flex flex-column pt-2">
                        <p routerLink="/task-Unassign" class="m-0 align-content-center" style="height: 54px; cursor: pointer;">
                            Task Unassigned
                        </p>
                        <div [ngStyle]="{'border': dataService.pageTitle === 'Task Assigend' ? '2px solid' : ''}" ></div>
                    </div>
                     -->
                    

                    <!-- <div *ngIf="dataService.role == 'doctor'"  class="d-flex flex-column pt-2">
                        <p routerLink="/designer-list" class="m-0 align-content-center" style="height: 54px; cursor: pointer;">
                            Designers
                        </p>
                        <div [ngStyle]="{'border': dataService.pageTitle === 'Designer List' ? '2px solid' : ''}" ></div>
                    </div> -->

                </div>
            </div>
            <div class="d-flex align-items-center gap-2 px-5 py-2">
                <!-- <div style="font-size: medium; line-height: 18px;">{{dataService.userId}}</div> -->
                <!-- <div style="font-size: small; line-height: 18px;">{{dataService.role}}</div> -->
                <button *ngIf="dataService.role == 'doctor'" matTooltipPosition="above" matTooltip="Cart" mat-icon-button (click)="onCartClick($event)">
                    <span matBadge="{{dataService.cartCount}}" class="custom-badge-button material-symbols-outlined" translate="no">shopping_cart</span>
                </button>
                

                <div class="d-inline-block"  ngbDropdown placement="bottom-end" #notifDrop="ngbDropdown" container="body" >

               <button class="btn btn-link p-0 position-relative" mat-icon-button ngbDropdownToggle matTooltip="Notifications"  matTooltipPosition="above" aria-label="Notifications">
               <span class="material-symbols-outlined" translate="no">notifications</span>
               <span
  *ngIf="dataService.role === 'doctor' && (drNotifications?.length || 0) > 0"
  class="position-absolute start-100 translate-middle badge rounded-pill bg-danger notication-count"
  style="font-size:.65rem"
>
  {{ drNotifications.length }}
  <span class="visually-hidden">unread notifications</span>
</span>

<span
  *ngIf="dataService.role === 'designer' && (notifications?.length || 0) > 0"
  class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
  style="font-size:.65rem"
>
  {{ notifications.length }}
  <span class="visually-hidden">unread notifications</span>
</span>

  </button>

  <div
    ngbDropdownMenu
    class="shadow-sm p-0 dropdown-menu-end notif-menu"
    aria-labelledby="dropdownManual"
  >
    <ul class="nav nav-pills nav-fill rounded gap-2 flex-column m-0">

    
      <li class="nav-item p-0">
       
        <div class="notif-scroll">
          <!-- Header and badge count -->
          <div class="dropdown-header d-flex justify-content-between align-items-center p-2">
            <h6 class="mb-0">Notifications ({{ activeNotifications.length }})</h6>
            <span class="badge">{{ activeNotifications.length }}</span>
          </div>
        
          <!-- No notifications -->
          <div class="text-center py-3" *ngIf="(activeNotifications?.length || 0) === 0">
            <p class="mb-0">No new news</p>
          </div>
        
          <!-- Doctor notifications -->
          <div *ngIf="dataService.role === 'doctor' && (activeNotifications?.length || 0) > 0" class="d-flex flex-column gap-2 p-2">
            <div *ngFor="let n of activeNotifications; index as i" class="customNotificationPills d-flex flex-column">
                <div
                class="d-flex gap-3 align-items-start justify-content-between w-100"
                (click)="updateDrNotification(n.taskId, i); notifDrop.close();navigateToOrderDetails(n.taskId, n.status); notifDrop.close()"
              >
                <span class="imageNotification">G</span>
              
                <span class="w-100 text-start mainLineNotification">
                  <!-- Conditional message -->
                  <span *ngIf="n.newMessage === 1; else deliveredMsg">
                    You have a new message
                  </span>
                  <ng-template #deliveredMsg>
                    Your Task has been Delivered
                  </ng-template>
              
                  <span class="fw-normal">{{ n.taskId }}</span>
                </span>
              
                <span class="dateAgoNotification">{{ n.notifiedAt }}</span>
              </div>
              
        
              <div class="d-flex align-items-center justify-content-center gap-2" *ngIf="n.status === 'NOTIFIED'">
                <button class="notificationButtonDecline" (click)="updateTask(n.taskId, 'decline')">Decline order</button>
                <button class="notificationButtonAccept" (click)="updateTask(n.taskId, 'accept')">Accept order</button>
              </div>
            </div>
          </div>
        
          <!-- Designer notifications -->
          <div *ngIf="dataService.role === 'designer' && (activeNotifications?.length || 0) > 0" class="d-flex flex-column gap-2 p-2">
            <div *ngFor="let n of activeNotifications; index as i" class="customNotificationPills d-flex flex-column">
              <div
                class="d-flex gap-3 align-items-start justify-content-between w-100"
                (click)="navigateToOrderDetails(n.taskId, n.status); notifDrop.close();updateDrNotification(n.taskId, i)"
              >
                <span class="imageNotification">G</span>
                <span class="w-100 text-start mainLineNotification">
                  <span *ngIf="n.status === 'NOTIFIED'">{{ n.crtBy }} wants to work with you</span>
                  <span class="fw-normal" *ngIf="n.status === 'NOTIFIED'">
                    {{ n.tier }} • {{ n.deliveryTime }} hrs • {{ n.amount }}€
                  </span>
                  <span *ngIf="n.status === 'CANCELED'">{{ n.crtBy }} canceled the order</span>
                  <span class="fw-normal" *ngIf="n.status === 'CANCELED'">{{ n.taskId }}</span>
                </span>
                <span class="dateAgoNotification">{{ n.notifiedAt }}</span>
              </div>
        
              <div class="d-flex align-items-center justify-content-center gap-2" *ngIf="n.status === 'NOTIFIED'">
                <button class="notificationButtonDecline" (click)="updateTask(n.taskId, 'decline')">Decline order</button>
                <button class="notificationButtonAccept" (click)="updateTask(n.taskId, 'accept')">Accept order</button>
              </div>
            </div>
          </div>
        </div>
        ```
        
      </li>

    </ul>
  </div>


</div>




                <!-- Availability Toggle Button -->
                <div class="d-flex align-items-center gap-2" *ngIf="dataService.role == 'designer'">
                    <hr style="height: 35px; width: 2px; background-color: #E4E4E4; border-top: none; opacity: 1;">
                    <label class="mx-1">Available</label>
                    <span class="slider-spinner-wrapper" style="position: relative; display: inline-block;">
                        <mat-slide-toggle
                            class="availability-toggle"
                            [checked]="isAvailable"
                            (change)="onToggleAvailability($event)"
                            [disabled]="isTogglingAvailability"
                            color="primary">
                        </mat-slide-toggle>
                        <span *ngIf="isTogglingAvailability" class="slider-spinner-inside">
                            <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                        </span>
                    </span>
                </div>



                <hr style="height: 35px; width: 2px; background-color: #E4E4E4; border-top: none; opacity: 1;">

                <div class="d-inline-block" ngbDropdown placement="bottom" #myDrop="ngbDropdown" container="body">
                    
                    <div *ngIf="!dataService.displayImageBytes" class="avatar" ngbDropdownToggle (click)="$event.stopPropagation(); myDrop.open()">{{dataService.initials}}</div>

                    <div class="mx-2" *ngIf="dataService.displayImageBytes" ngbDropdownToggle (click)="$event.stopPropagation(); myDrop.open()" style="cursor: pointer; width: 35px; aspect-ratio: 1; background-color: #008A70; border-radius: 50%; background-image: url('data:image/png;base64,{{ dataService.displayImageBytes }}'); background-size: cover; background-position: center;border: 1px solid rgba(0, 0, 0, 0.466);"></div>
                    
                    <div ngbDropdownMenu aria-labelledby="dropdownManual" style="right: -150px; top: 6px; width: 250px; border: none;" class="shadow p-0">
                        <!-- <button ngbDropdownItem *ngIf="dataService.isActive"
                            class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                            routerLink="/user-profile">
                            <mat-icon>account_circle</mat-icon><span>Profile</span>
                        </button>
                        <button *ngIf="!dataService.isOauthUser && dataService.isActive" ngbDropdownItem
                            class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                            routerLink="/change-password">
                            <mat-icon>key</mat-icon><span>Change Password</span>
                        </button> 
                       
                        <button ngbDropdownItem
                            class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap gap-3 w-100 px-3"
                            mat-menu-item (click)="logout()">
                            <mat-icon>logout</mat-icon><span>Logout</span>
                        </button> -->


                        <ul class="nav nav-pills nav-fill rounded p-2 gap-2 flex-column">
                            <li ngbDropdownItem class="nav-item" style="background-color: #FAF9F9; border-radius: 7px;" routerLink="/user-profile">
                                <a href="javascript:void(0)" class="nav-link text-start align-items-center gap-2 d-flex" style="color: black;">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 12C13.1867 12 14.3467 11.6481 15.3334 10.9888C16.3201 10.3295 17.0892 9.39246 17.5433 8.2961C17.9974 7.19975 18.1162 5.99335 17.8847 4.82946C17.6532 3.66558 17.0818 2.59648 16.2426 1.75736C15.4035 0.918247 14.3344 0.346802 13.1705 0.115291C12.0067 -0.11622 10.8003 0.00259972 9.7039 0.456726C8.60754 0.910851 7.67047 1.67989 7.01118 2.66658C6.35189 3.65328 6 4.81331 6 6C6.00159 7.59081 6.63424 9.11602 7.75911 10.2409C8.88399 11.3658 10.4092 11.9984 12 12ZM12 2C12.7911 2 13.5645 2.2346 14.2223 2.67412C14.8801 3.11365 15.3928 3.73836 15.6955 4.46927C15.9983 5.20017 16.0775 6.00444 15.9231 6.78036C15.7688 7.55629 15.3878 8.26902 14.8284 8.82843C14.269 9.38784 13.5563 9.7688 12.7804 9.92314C12.0044 10.0775 11.2002 9.99827 10.4693 9.69552C9.73836 9.39277 9.11365 8.88008 8.67412 8.22228C8.2346 7.56449 8 6.79113 8 6C8 4.93914 8.42143 3.92172 9.17157 3.17158C9.92172 2.42143 10.9391 2 12 2Z" fill="black"/>
                                        <path d="M12 14C9.61386 14.0026 7.32622 14.9517 5.63896 16.639C3.95171 18.3262 3.00265 20.6139 3 23C3 23.2652 3.10536 23.5196 3.29289 23.7071C3.48043 23.8946 3.73478 24 4 24C4.26522 24 4.51957 23.8946 4.70711 23.7071C4.89464 23.5196 5 23.2652 5 23C5 21.1435 5.7375 19.363 7.05025 18.0503C8.36301 16.7375 10.1435 16 12 16C13.8565 16 15.637 16.7375 16.9497 18.0503C18.2625 19.363 19 21.1435 19 23C19 23.2652 19.1054 23.5196 19.2929 23.7071C19.4804 23.8946 19.7348 24 20 24C20.2652 24 20.5196 23.8946 20.7071 23.7071C20.8946 23.5196 21 23.2652 21 23C20.9974 20.6139 20.0483 18.3262 18.361 16.639C16.6738 14.9517 14.3861 14.0026 12 14Z" fill="black"/>
                                    </svg>
                                    <span class="px-1">Profile</span>
                                </a>
                            </li>
                            <li *ngIf="!dataService.isOauthUser" ngbDropdownItem class="nav-item" style="background-color: #FAF9F9; border-radius: 7px;" (click)="openChangePasswordModal()">
                                <a href="javascript:void(0)" class="nav-link text-start align-items-center gap-2 d-flex" style="color: black;">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_728_9456)">
                                            <path d="M7.50498 24C5.69473 23.9989 3.94598 23.343 2.58143 22.1535C1.21688 20.9639 0.328614 19.321 0.0805405 17.5278C-0.167533 15.7346 0.241329 13.9122 1.23168 12.3969C2.22203 10.8816 3.72703 9.7756 5.46898 9.28302C6.7351 8.92045 8.07527 8.90387 9.34998 9.23502L17.258 1.32902C17.6778 0.906302 18.1774 0.571153 18.7277 0.343015C19.2781 0.114877 19.8682 -0.0017098 20.464 1.89472e-05C21.4015 0.000813379 22.3005 0.37361 22.9634 1.03657C23.6264 1.69952 23.9992 2.59846 24 3.53602C24.0015 4.13181 23.885 4.722 23.657 5.27246C23.4291 5.82292 23.0943 6.32274 22.672 6.74302L22 7.41502C21.624 7.78846 21.1159 7.99865 20.586 8.00002H19V9.00002C19 9.53045 18.7893 10.0392 18.4142 10.4142C18.0391 10.7893 17.5304 11 17 11H16V12.586C16.0007 12.8488 15.9493 13.109 15.8487 13.3517C15.7481 13.5945 15.6003 13.8148 15.414 14L14.764 14.65C15.0969 15.9241 15.0807 17.2644 14.717 18.53C14.3077 19.972 13.4773 21.259 12.3321 22.2262C11.1869 23.1934 9.77913 23.7968 8.28898 23.959C8.02852 23.9861 7.76684 23.9998 7.50498 24ZM7.50498 11C6.48113 10.999 5.47732 11.2838 4.60656 11.8224C3.73581 12.361 3.03266 13.1319 2.57628 14.0484C2.1199 14.9649 1.92841 15.9906 2.02335 17.0101C2.1183 18.0295 2.49591 19.0022 3.1137 19.8187C3.73148 20.6351 4.5649 21.2629 5.52013 21.6314C6.47537 21.9999 7.51451 22.0945 8.52057 21.9044C9.52662 21.7144 10.4597 21.2473 11.2147 20.5557C11.9696 19.8642 12.5166 18.9756 12.794 17.99C13.106 16.9066 13.071 15.7526 12.694 14.69C12.6324 14.5126 12.6221 14.3214 12.6642 14.1383C12.7063 13.9553 12.7991 13.7878 12.932 13.655L14 12.586V11C14 10.4696 14.2107 9.96088 14.5858 9.58581C14.9608 9.21073 15.4695 9.00002 16 9.00002H17V8.00002C17 7.46959 17.2107 6.96088 17.5858 6.58581C17.9608 6.21073 18.4695 6.00002 19 6.00002H20.586L21.258 5.32802C21.4939 5.09317 21.681 4.81388 21.8084 4.5063C21.9357 4.19871 22.0008 3.86893 22 3.53602C21.9997 3.1289 21.8379 2.73852 21.5502 2.45055C21.2624 2.16258 20.8721 2.00055 20.465 2.00002C20.1318 1.9992 19.8018 2.06445 19.4941 2.19198C19.1863 2.31951 18.9069 2.5068 18.672 2.74302L10.341 11.073C10.208 11.2059 10.0403 11.2986 9.85707 11.3405C9.67383 11.3825 9.48248 11.3719 9.30498 11.31C8.72505 11.1058 8.1148 11.001 7.49998 11H7.50498ZM4.99998 18C4.99998 18.1978 5.05863 18.3911 5.16851 18.5556C5.27839 18.72 5.43457 18.8482 5.61729 18.9239C5.80002 18.9996 6.00109 19.0194 6.19507 18.9808C6.38905 18.9422 6.56723 18.847 6.70708 18.7071C6.84694 18.5673 6.94218 18.3891 6.98076 18.1951C7.01935 18.0011 6.99954 17.8001 6.92386 17.6173C6.84817 17.4346 6.72 17.2784 6.55555 17.1685C6.3911 17.0587 6.19776 17 5.99998 17C5.73476 17 5.48041 17.1054 5.29287 17.2929C5.10533 17.4804 4.99998 17.7348 4.99998 18Z" fill="black"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_728_9456">
                                                <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span class="px-1">Change Password</span>
                                </a>
                            </li>
                            <li ngbDropdownItem class="nav-item" style="background-color: #FAF9F9; border-radius: 7px;" (click)="logout()">
                                <a href="javascript:void(0)" class="nav-link text-start align-items-center gap-2 d-flex" style="color: black;">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_728_9452)">
                                            <path d="M11.476 15C11.2108 15 10.9564 15.1054 10.7689 15.2929C10.5814 15.4804 10.476 15.7348 10.476 16V19C10.476 19.7956 10.1599 20.5587 9.59732 21.1213C9.03471 21.6839 8.27165 22 7.476 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H7.476C8.27165 2 9.03471 2.31607 9.59732 2.87868C10.1599 3.44129 10.476 4.20435 10.476 5V8C10.476 8.26522 10.5814 8.51957 10.7689 8.70711C10.9564 8.89464 11.2108 9 11.476 9C11.7412 9 11.9956 8.89464 12.1831 8.70711C12.3706 8.51957 12.476 8.26522 12.476 8V5C12.4744 3.67441 11.9471 2.40356 11.0098 1.46622C10.0724 0.528882 8.80159 0.00158786 7.476 0H5C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.67441 23.9984 5 24H7.476C8.80159 23.9984 10.0724 23.4711 11.0098 22.5338C11.9471 21.5964 12.4744 20.3256 12.476 19V16C12.476 15.7348 12.3706 15.4804 12.1831 15.2929C11.9956 15.1054 11.7412 15 11.476 15Z" fill="black"/>
                                            <path d="M22.867 9.87896L18.281 5.29296C18.1888 5.19745 18.0784 5.12127 17.9564 5.06886C17.8344 5.01645 17.7032 4.98886 17.5704 4.98771C17.4376 4.98655 17.3059 5.01186 17.183 5.06214C17.0602 5.11242 16.9485 5.18667 16.8546 5.28056C16.7607 5.37446 16.6865 5.48611 16.6362 5.60901C16.5859 5.7319 16.5606 5.86358 16.5618 5.99636C16.5629 6.12914 16.5905 6.26036 16.6429 6.38236C16.6953 6.50437 16.7715 6.61471 16.867 6.70696L21.129 10.97L6 11C5.73478 11 5.48043 11.1053 5.29289 11.2929C5.10536 11.4804 5 11.7347 5 12C5 12.2652 5.10536 12.5195 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13L21.188 12.969L16.865 17.293C16.7695 17.3852 16.6933 17.4956 16.6409 17.6176C16.5885 17.7396 16.5609 17.8708 16.5598 18.0036C16.5586 18.1363 16.5839 18.268 16.6342 18.3909C16.6845 18.5138 16.7587 18.6255 16.8526 18.7194C16.9465 18.8132 17.0582 18.8875 17.181 18.9378C17.3039 18.9881 17.4356 19.0134 17.5684 19.0122C17.7012 19.0111 17.8324 18.9835 17.9544 18.9311C18.0764 18.8787 18.1868 18.8025 18.279 18.707L22.865 14.121C23.4277 13.5586 23.744 12.7959 23.7444 12.0004C23.7447 11.2049 23.4292 10.4418 22.867 9.87896Z" fill="black"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_728_9452">
                                                <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span class="px-1">Logout</span>
                                </a>
                            </li>
                        </ul>


                    </div>
                </div>

                <div class="d-flex flex-column" (click)="myDrop.open()" style="cursor: pointer;">
                    <p class="m-0">{{dataService.firstName | titlecase}} {{dataService.lastName | titlecase}}</p>
                    <p class="m-0" style="font-size: 14px; color: #707070;">{{dataService.role | titlecase}}</p>
                </div>

            </div>
        </div>
        <div class="h-100 w-100 ">
            <div class="p-0 h-100 w-100 ">
                <router-outlet></router-outlet>
                <!-- <div class="version-banner">
                    gity&copy; v{{ version }}
                </div> -->
            </div>
        </div>
        <!-- ###############################    Mobile view #################################-->
        <!-- <div class="d-flex justify-content-start d-flex d-md-none d-lg-none d-xl-none"
            style="backdrop-filter: blur(10px);background: rgba(255,255,255,0.8);">
            <div class="d-flex justify-content-around flex-row gap-2 w-100 p-1">
                <button [ngClass]="{ 'active': dataService.pageTitle === 'Dashboard' }"
                    class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap px-3"
                    mat-menu-item routerLink="/dashboard">
                    <mat-icon>dashboard icon</mat-icon>
                </button>
                <button [ngClass]="{ 'active': dataService.pageTitle === 'My Tasks' }"
                    class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap px-3"
                    mat-menu-item routerLink="/task-list/my" *ngIf="dataService.role == 'designer'">
                    <mat-icon>pending_actions</mat-icon>
                </button>
                <button [ngClass]="{ 'active': dataService.pageTitle === 'In Progress Tasks' }"
                    class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap px-3"
                    mat-menu-item routerLink="/task-list/in-progress">
                    <mat-icon>pending_actions</mat-icon>
                </button>
                <button [ngClass]="{ 'active': dataService.pageTitle === 'Completed Tasks' }"
                    class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap px-3"
                    mat-menu-item routerLink="/task-list/complete">
                    <mat-icon>check_circle</mat-icon>
                </button>
                <button [ngClass]="{ 'active': dataService.pageTitle === 'Create New Task' }"
                    class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap px-3"
                    mat-menu-item routerLink="/create-task-demo" *ngIf="dataService.role == 'doctor'">
                    <mat-icon>add</mat-icon>New Task
                </button>
                <button [ngClass]="{ 'active': dataService.pageTitle === '' }"
                    class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap px-3"
                    routerLink="/user-list" *ngIf="dataService.role === 'tl' || dataService.role === 'admin'">
                    <mat-icon>supervised_user_circle</mat-icon>User List
                </button>
                <button [ngClass]="{ 'active': dataService.pageTitle === '' }"
                    class="customButtonsLeftMenue rounded-pill btn btn-sm d-flex align-items-center text-start text-nowrap px-3"
                    routerLink="/admin" *ngIf="dataService.role === 'admin'">
                    <mat-icon>admin_panel_settings</mat-icon>Admin
                </button>
            </div>
        </div> -->
    </div>
</div>



<div class="spinner-overlay" *ngIf="dataService.progressBarActive">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>